import { ReactNode } from 'react';
import styles from './Disclaimer.module.css';

const Disclaimer: React.FC<{ children?: ReactNode }> = ({ children }) => {
    return <div className={styles.disclaimer}>{children}</div>;
};

export default Disclaimer;
